import React, { Component, Fragment } from 'react'
import {Container,Row,Col,Card} from 'react-bootstrap'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import frispy from '../../assets/images/clients/FRISPY.png';
import grandy from '../../assets/images/clients/GRADYHOTEL.png';
import oakcafe from '../../assets/images/clients/OAKCAFE.png';
import quickpick from '../../assets/images/clients/QUICKPICK.png';
import SEACOLECARE from '../../assets/images/clients/SEACOLECARE.png';
import GOLDLINESSACCO from '../../assets/images/clients/GOLDLINESSACCO.png';
import lotus from '../../assets/images/clients/lotus.png';
import CHECKMATE from '../../assets/images/clients/CHECKMATE.png';
import cafelounge from '../../assets/images/clients/cafe-lounge.png';

class NewArrival extends Component {

     constructor(props){
          super(props);
          this.next=this.next.bind(this);
          this.previous=this.previous.bind(this)
     }

     next(){
          this.slider.slickNext();
     }

     previous(){
          this.slider.slickPrev();
     }

     render() {

          var settings = {
               dots: false,
               infinite: true,
               speed: 500,
               autoplay: true,
               autoplaySpeed:3000,
               slidesToShow: 4,
               slidesToScroll: 1,
               initialSlide: 0,
               arrows: false,
               responsive: [
                 {
                   breakpoint: 1024,
                   settings: {
                     slidesToShow: 4,
                     slidesToScroll: 1,
                     infinite: true,
                     dots: true
                   }
                 },
                 {
                   breakpoint: 600,
                   settings: {
                     slidesToShow: 2,
                     slidesToScroll: 1,
                     initialSlide: 2
                   }
                 },
                 {
                   breakpoint: 480,
                   settings: {
                     slidesToShow: 1,
                     slidesToScroll: 1
                   }
                 }
               ]
             };

          return ( 
               <Fragment>

          <Container className="text-center" fluid={true}>

          <div className="section-title text-center mb-55">

          <h2>
          OUR CLIENTS &nbsp;

          <a className="btn btn-sm ml-2 site-btn" onClick={this.previous}>
          <i className="fa fa-angle-left"></i>
          </a>

          &nbsp;

          <a className="btn btn-sm ml-2 site-btn" onClick={this.next}>
          <i className="fa fa-angle-right"></i>
          </a>

          </h2>

          <p>
          We are proud to partner with businesses across different industries.
          Our software solutions help organizations manage operations efficiently,
          improve customer service, and grow their businesses.
          </p>

          <p>
          Below are some of the clients who trust our systems in their daily operations.
          </p>

          </div>

          <Row>

          <Slider ref={c => (this.slider = c)} {...settings}>

          {/* FRISPY */}

          <div>
          <Card className="image-box card">

          <a href="https://frispykremeinvestments.com/" target="_blank" rel="noopener noreferrer">
          <img className="center" src={frispy} alt="frispy" />
          </a>

          <Card.Body>
          <p className="product-name-on-card">
          FRISPY CLEANING AND FUMIGATION
          </p>
          </Card.Body>

          </Card>
          </div>

          {/* GRANDY HOTEL */}

          <div>
          <Card className="image-box card">

          <a href="https://gradyhotel.com/" target="_blank" rel="noopener noreferrer">
          <img className="center" src={grandy} alt="grandy" />
          </a>

          <Card.Body>
          <p className="product-name-on-card">
          Grandy Hotel
          </p>
          </Card.Body>

          </Card>
          </div>

          {/* OAK CAFE */}

          <div>
          <Card className="image-box card">

          <a href="http://oak-cafe.com/" target="_blank" rel="noopener noreferrer">
          <img className="center" src={oakcafe} alt="oakcafe" />
          </a>

          <Card.Body>
          <p className="product-name-on-card">
          Oak Cafe
          </p>
          </Card.Body>

          </Card>
          </div>

          {/* QUICK PICK */}

          <div>
          <Card className="image-box card">

          <a href="http://quickpicksupermarkets.com/" target="_blank" rel="noopener noreferrer">
          <img className="center" src={quickpick} alt="quickpick" />
          </a>

          <Card.Body>
          <p className="product-name-on-card">
          QUICK PICK SUPERMARKET
          </p>
          </Card.Body>

          </Card>
          </div>

          {/* SEACOLE CARE */}

          <div>
          <Card className="image-box card">

          <a href="http://seacolecare.co.uk/" target="_blank" rel="noopener noreferrer">
          <img className="center" src={SEACOLECARE} alt="seacolecare" />
          </a>

          <Card.Body>
          <p className="product-name-on-card">
          SEACOLE CARE
          </p>
          </Card.Body>

          </Card>
          </div>

          {/* LOTUS */}

          <div>
          <Card className="image-box card">

          <a href="http://lotuslogistics-ltd.com/" target="_blank" rel="noopener noreferrer">
          <img className="center" src={lotus} alt="lotus" />
          </a>

          <Card.Body>
          <p className="product-name-on-card">
          LOTUS LOGISTIC COMPANY
          </p>
          </Card.Body>

          </Card>
          </div>

          {/* GOLDLINE SACCO */}

          <div>
          <Card className="image-box card">

          <a href="https://goldlinessacco.com/" target="_blank" rel="noopener noreferrer">
          <img className="center" src={GOLDLINESSACCO} alt="goldline" />
          </a>

          <Card.Body>
          <p className="product-name-on-card">
          GOLDLINE SACCO
          </p>
          </Card.Body>

          </Card>
          </div>

          {/* CHECKMATE */}

          <div>
          <Card className="image-box card">

          <a href="https://checkmateug.com/" target="_blank" rel="noopener noreferrer">
          <img className="center" src={CHECKMATE} alt="checkmate" />
          </a>

          <Card.Body>
          <p className="product-name-on-card">
          CHECKMATE
          </p>
          </Card.Body>

          </Card>
          </div>

          {/* CAFE & LOUNGE */}

          <div>
          <Card className="image-box card">

          <a href="https://latitude8restaurantandlounge.com/" target="_blank" rel="noopener noreferrer">
          <img className="center" src={cafelounge} alt="cafelounge" />
          </a>

          <Card.Body>
          <p className="product-name-on-card">
           Latitude8 Restaurant Cafe and Lounge
         
          </p>
          </Card.Body>

          </Card>
          </div>
<div>
          <Card className="image-box card">

          <a href="https://atro-group.com/" target="_blank" rel="noopener noreferrer">
          <img className="center" src={cafelounge} alt="cafelounge" />
          </a>

          <Card.Body>
          <p className="product-name-on-card">
          ATRO-GROUP
         
          </p>
          </Card.Body>

          </Card>
          </div>
          </Slider>

          </Row>

          </Container>

          </Fragment>
          )
     }
}

export default NewArrival;